export default __webpack_public_path__ + "static/media/avatar_male.887dda37.png";